<div
  class="profile-image"
  [class.profile-image--card]="variant === 'card'"
  [class.profile-image--editable]="canEdit"
  [class.profile-image--previewable]="canPreviewImage"
  [style.width.px]="size"
  [style.height.px]="size"
>
  @if (showPlaceholderImage) {
  <img
    [src]="placeholderSrc!"
    [alt]="fallbackInitials"
    class="profile-image__img"
    [matTooltip]="previewTooltip"
    (click)="onImageClick($event)"
  />
  } @if (imageSrc) {
  <img
    [src]="imageSrc"
    [alt]="fallbackInitials"
    class="profile-image__img"
    [matTooltip]="previewTooltip"
    (click)="onImageClick($event)"
  />
  } @if (fallbackInitialsDisplay) {
  <span class="profile-image__initials">{{ fallbackInitials }}</span>
  } @if (isLoading || isUploading) {
  <div class="profile-image__overlay">
    <mat-spinner [diameter]="spinnerSize"></mat-spinner>
    @if (isUploading && uploadProgress > 0) {
    <span class="profile-image__progress">{{ uploadProgress }}%</span>
    }
  </div>
  } @if (canEdit && !isUploading) {
  <button
    type="button"
    class="profile-image__edit-btn"
    matTooltip="Skift billede"
    (click)="$event.stopPropagation(); triggerFileInput(fileInput)"
  >
    <mat-icon>photo_camera</mat-icon>
  </button>
  }

  <input
    #fileInput
    type="file"
    accept="image/jpeg,image/png,image/gif,image/webp,image/svg+xml,image/bmp,image/tiff"
    class="profile-image__file-input"
    (change)="onFileSelected($event)"
  />
</div>

<app-picture-modal></app-picture-modal>
